import { v4 as uuidv4 } from 'uuid'
import { IModelBaseModel } from '../model-base/model-base.interface'
import { ModelBaseModel } from '../model-base/model-base.model'
import { ISpectatorTickets } from './spectator-tickets.interface'
import { CONST } from '../../const/const'

const COLLECTIONS = CONST.DATA.FIRESTORE.LATEST.COLLECTIONS

export class SpectatorTicketModel
  extends ModelBaseModel<ISpectatorTickets>
  implements IModelBaseModel
{
  public id: ISpectatorTickets['id']
  public userId: ISpectatorTickets['userId']
  public userName: ISpectatorTickets['userName']
  public eventDocId: ISpectatorTickets['eventDocId']
  public ticketPrice: ISpectatorTickets['ticketPrice']
  public isPlatformUser: ISpectatorTickets['isPlatformUser']
  public userEmailId: ISpectatorTickets['userEmailId']
  public recipientProfilePicture: ISpectatorTickets['recipientProfilePicture']
  public ticketsCountAgainstSpectatorDoc: ISpectatorTickets['ticketsCountAgainstSpectatorDoc']
  public selectedUnitsCount: ISpectatorTickets['selectedUnitsCount']
  public sharedTicketsCount: ISpectatorTickets['sharedTicketsCount']
  public boughtTicketCount: ISpectatorTickets['boughtTicketCount']
  public ticketItemId: ISpectatorTickets['ticketItemId']
  public ticketTitle: ISpectatorTickets['ticketTitle']
  public ticketBuyerDocId: ISpectatorTickets['ticketBuyerDocId']
  public paymentStatus: ISpectatorTickets['paymentStatus']
  public paymentType: ISpectatorTickets['paymentType']
  public transactionDocId: ISpectatorTickets['transactionDocId']
  public purchasedOn: ISpectatorTickets['purchasedOn']
  public created: ISpectatorTickets['created']
  public modified: ISpectatorTickets['modified']

  public constructor(obj?: ISpectatorTickets) {
    super()
    this.id = obj?.id
    this.userId = obj?.userId ?? COLLECTIONS.REGISTRATION_TICKET.FIELDS.USER_ID.VALUES.DEFAULT
    this.userName = obj?.userName ?? null
    this.ticketPrice = obj?.ticketPrice ?? 0
    this.eventDocId = obj?.eventDocId ?? null
    this.userEmailId = obj?.userEmailId ?? null
    this.purchasedOn = obj?.purchasedOn ?? null
    this.ticketTitle = obj?.ticketTitle ?? null
    this.ticketItemId = obj?.ticketItemId ?? null
    this.isPlatformUser = obj?.isPlatformUser ?? false
    this.ticketBuyerDocId = obj?.ticketBuyerDocId ?? null
    this.paymentStatus =
      obj?.paymentStatus ?? COLLECTIONS.REGISTRATION_TICKET.FIELDS.PAYMENT_STATUS.VALUES.DEFAULT
    this.paymentType =
      obj?.paymentType ?? COLLECTIONS.REGISTRATION_TICKET.FIELDS.PAYMENT_STATUS.VALUES.DEFAULT
    this.boughtTicketCount = obj?.boughtTicketCount ?? 0
    this.selectedUnitsCount = obj?.selectedUnitsCount ?? 0
    this.sharedTicketsCount = obj?.sharedTicketsCount ?? 0
    this.transactionDocId = obj?.transactionDocId ?? null
    this.recipientProfilePicture = obj?.recipientProfilePicture ?? null
    this.ticketsCountAgainstSpectatorDoc = obj?.ticketsCountAgainstSpectatorDoc ?? 0

    this.created = this.utcTimestamp({
      key: 'created',
      isTimestamp: true,
      value: obj?.created,
    })

    this.modified = this.utcTimestamp({
      key: 'modified',
      isTimestamp: true,
      changeOnUpdate: true,
      value: obj?.modified,
    })
  }

  static fromFirestoreDoc(doc: any) {
    return new SpectatorTicketModel({
      id: doc.id,
      ...doc.data(),
    })
  }

  static getUuid(uuid?: any) {
    let uuid_
    if (typeof uuid !== 'string') uuid_ = uuidv4()
    else uuid_ = uuid
    uuid_ = uuid_.trim()
    return uuid_
  }
}
